import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
import { UtilitiesService } from '@app/shared/services/utilities/utilities.service';
import { untilDestroyed } from '@app/core/until-destroyed';
import { CredentialsService } from '@app/core/authentication/credentials.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnDestroy, OnInit {
  @Input() futureSessions: boolean;
  public homeAdvertisings: any[] = [];
  onHome: boolean = true;
  public showAdds: boolean = true;
  addCounter: number = 0;

  constructor(
    private fireService: FirebaseService,
    public utilities: UtilitiesService,
    public credService: CredentialsService,
    public router: Router
  ) { }

  ngOnInit() {
    this.routerAdvertising();
  }

  async routerAdvertising() {
    const RESP = await this.fireService.afs
      .collection('advertising')
      .ref.orderBy('order', 'asc')
      .get();
    this.homeAdvertisings = RESP.docs.filter(item => {
      return this.utilities.showAdd(item.data());
    }).map(element => {
      const DATA: any = element.data();
      const ID: string = element.id;
      return { id: ID, ...DATA };
    });
    this.router.events.pipe(untilDestroyed(this)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.router.url === '/home' && !this.onHome) {
          if (this.homeAdvertisings.length !== 0) {
            this.showAdds = true;
            this.addCounter = this.addCounter + 1;
            if (this.addCounter >= this.homeAdvertisings.length) {
              this.addCounter = 0;
            }
          }
        }
        if (this.router.url !== '/home') {
          this.onHome = false;
        } else {
          this.onHome = true;
        }
      }
    });
  }

  ngOnDestroy() {
    // Empty but required by untilDestroyed
  }
}